const notificationListPage = {
  title: "Tilkynningamiðstöð",
  unreadBadge: "{{count}} ólesið",
  compose: {
    button: "Skrifa",
    title: "Senda tilkynningu til annarra notenda",
  },
  markAllAsRead: "Merkja allt lesið",
  tabs: {
    all: "Allt",
    unreadOnly: "Aðeins ólesið",
  },
  loading: "Hleð tilkynningum...",
  loadFailed: "Ekki tókst að sækja tilkynningar",
  empty: {
    unread: "Engar ólesnar tilkynningar",
    all: "Engar tilkynningar",
  },
  pagination: {
    pageOf: "Síða {{current}} af {{total}}",
  },
};

export default notificationListPage;
